import React from "react";

const OrdersTable = () => {
  const orders = [
    {
      id: 1,
      status: "Processing",
      payment: "Paid",
      shipping: "Not yet shipped",
      customer: "Steve Gates",
      email: "steve_gates@routekart.com",
      created: "02/11/2025 10:34:46 PM",
      total: "$1,855.00",
    },
    {
      id: 2,
      status: "Pending",
      payment: "Pending",
      shipping: "Not yet shipped",
      customer: "Arthur Holmes",
      email: "arthur_holmes@routekart.com",
      created: "02/11/2025 10:34:46 PM",
      total: "$2,460.00",
    },
    {
      id: 3,
      status: "Pending",
      payment: "Pending",
      shipping: "Shipping not required",
      customer: "James Pan",
      email: "james_pan@routekart.com",
      created: "02/11/2025 10:34:46 PM",
      total: "$8.80",
    },
    {
      id: 4,
      status: "Processing",
      payment: "Paid",
      shipping: "Shipped",
      customer: "Brenda Lindgren",
      email: "brenda_lindgren@routekart.com",
      created: "02/11/2025 10:34:46 PM",
      total: "$102.00",
    },
    {
      id: 5,
      status: "Complete",
      payment: "Paid",
      shipping: "Delivered",
      customer: "Victoria Terces",
      email: "victoria_victoria@routekart.com",
      created: "02/11/2025 10:34:46 PM",
      total: "$43.50",
    },
  ];

  return (
    <div className="bg-white shadow-lg rounded-2xl p-8 w-full overflow-x-auto min-h-screen">
      <h2 className="text-xl font-semibold mb-6">Learn more about <span className="text-blue-600 cursor-pointer">orders</span></h2>

      {/* Desktop Table */}
      <div className="hidden md:block">
        <table className="min-w-full text-base border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-4 border">Order #</th>
              <th className="p-4 border">Order status</th>
              <th className="p-4 border">Payment status</th>
              <th className="p-4 border">Shipping status</th>
              <th className="p-4 border">Customer</th>
              <th className="p-4 border">Created on</th>
              <th className="p-4 border">Order total</th>
              <th className="p-4 border">View</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="hover:bg-gray-50">
                <td className="p-4 border text-center">{order.id}</td>
                <td className="p-4 border text-center">
                  <span
                    className={`px-3 py-1 text-sm rounded-lg font-medium text-white ${
                      order.status === "Processing"
                        ? "bg-sky-500"
                        : order.status === "Pending"
                        ? "bg-amber-500"
                        : "bg-green-600"
                    }`}
                  >
                    {order.status}
                  </span>
                </td>
                <td className="p-4 border text-center">{order.payment}</td>
                <td className="p-4 border text-center">{order.shipping}</td>
                <td className="p-4 border">
                  <div>
                    <p className="text-base">{order.customer}</p>
                    <p className="text-blue-500 text-sm">{order.email}</p>
                  </div>
                </td>
                <td className="p-4 border text-center">{order.created}</td>
                <td className="p-4 border text-center">{order.total}</td>
                <td className="p-4 border text-center">
                  <button className="px-4 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-md">
                    👁 View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Responsive Tabs */}
      <div className="md:hidden grid gap-6 mt-4">
        {orders.map((order) => (
          <div key={order.id} className="border rounded-2xl p-5 shadow-sm bg-gray-50">
            <div className="flex justify-between items-center mb-3">
              <span className="text-base font-semibold">Order #{order.id}</span>
              <span
                className={`px-3 py-1 text-sm rounded-lg text-white ${
                  order.status === "Processing"
                    ? "bg-sky-500"
                    : order.status === "Pending"
                    ? "bg-amber-500"
                    : "bg-green-600"
                }`}
              >
                {order.status}
              </span>
            </div>
            <p className="text-sm mb-1">Payment: <span className="font-medium">{order.payment}</span></p>
            <p className="text-sm mb-1">Shipping: <span className="font-medium">{order.shipping}</span></p>
            <p className="text-sm mb-1">Customer: <span className="font-medium">{order.customer}</span></p>
            <p className="text-sm text-blue-500 mb-1">{order.email}</p>
            <p className="text-sm mb-3">Created: {order.created}</p>
            <div className="flex justify-between items-center mt-3">
              <p className="font-semibold text-base">{order.total}</p>
              <button className="text-sm bg-gray-100 px-4 py-2 rounded-md hover:bg-gray-200">👁 View</button>
            </div>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="flex justify-end mt-8">
        <div className="text-base text-right space-y-1">
          <p><span className="font-semibold">Profit:</span> $4,469.30</p>
          <p><span className="font-semibold">Shipping:</span> $0.00</p>
          <p><span className="font-semibold">Tax:</span> $0.00</p>
          <p className="font-bold mt-2 text-lg">Total: $4,469.30</p>
        </div>
      </div>
    </div>
  );
};

export default OrdersTable;